import { api } from './api';

export const fetchAdhocTypes = (params) => {
  return api.get('/pricing/invoice_item_type', params);
};

export const fetchAdhocTypesById = (id) => {
  return api.get(`/pricing/invoice_item_type/${id}`);
};

export const fetchPricingTypes = (params) => {
  return api.get('/pricing/pricing_types', params);
};

export const fetchRulesets = (params, options) => {
  return api.get('/pricing/rule_set', params, options);
};

export const fetchDeleteRuleset = (id, payload) => {
  return api.put(`/pricing/rule_set/${id}`, payload);
};

export const fetchAccountingTypes = (params) => {
  return api.get('/pricing/accounting_types', params);
};

export const fetchCreateRuleset = (params) => {
  return api.post('/pricing/rule_set', params);
};

export const fetchCreateTaxRuleset = (payload) => {
  return api.post('/pricing/tax_rules_set', payload);
};

export const fetchTaxRulesetById = (id) => {
  return api.get(`/pricing/tax_rules_set/${id}`);
};

export const fetchDeleteTaxRuleset = (id) => {
  return api.delete(`/pricing/tax_rules_set/${id}`);
};

export const fetchTaxRulesets = (params, options) => {
  return api.get('/pricing/tax_rules_set', params, options);
};

export const fetchRuleset = (id, params = {}) => {
  return api.get(`/pricing/rule_set/${id}`, params);
};

export const fetchUpdateRuleset = (id, payload) => {
  return api.post(`/pricing/rule_set/${id}/overwrite`, payload);
};

export const fetchRulesetVehicleGroups = (id, params) => {
  return api.get(`/pricing/rule_set/${id}/vehicle_group`, params);
};

export const fetchUpdateTaxRuleset = (id, payload) => {
  return api.post(`/pricing/tax_rules_set/${id}/overwrite`, payload);
};

export const fetchSKUsAssociated = (rulesetId, params) => {
  return api.get(`/pricing/tax_rules_set/${rulesetId}/invoice_item_type`, params);
};
